<div style="margin-top: 5px; height: calc(100vh - 100px - 40px); display: flex;">

  <div style="flex-grow: 1;"></div>

  <div style="width: 50%;">
    <div style="display: flex; justify-content: space-between; width: 100%;">
      <div style="margin-bottom: 10px;">
        <button type="button" pButton icon="fa fa-refresh" label="Update"
        (click)="rebuildDiscResultList()"></button>
      </div>
      @if (isAdminValid) {
        <button style="height: 90%; margin-top: 5px;" type="button" [disabled]="!isAdminValid" class="btn btn-danger"
          title="Delete all discovery results" (click)="tryDeleteAllResults($event)">
          Delete All...
        </button>
      }
    </div>
    <!-- Data table -->
    <p-table [value]="discResults" [scrollable]="true" [resizableColumns]="true"
      scrollHeight="calc(100vh - 180px - 32px)" rowHover="true">
      <ng-template pTemplate="header">
        <tr>
          <th pResizableColumn>Start Time</th>
          <th pResizableColumn>End Time</th>
          <th pResizableColumn>Devices</th>
          <th pResizableColumn class="uv-table-button-column-1"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr (click)="onDiscResultClick(rowData)">
          <td>
            <span class="uv-table-value">{{ formatDateHm(rowData.StartTime) }}</span>
          </td>
          <td>
            <span class="uv-table-value">{{ formatDateHm(rowData.EndTime) }}</span>
          </td>
          <td>
            <span class="uv-table-value">{{ rowData.DeviceCount }}</span>
          </td>
          <td class="uv-table-button-column-1">
            @if (isAdminValid) {
              <button type="button" [disabled]="!isAdminValid" class="btn btn-danger uv-first-table-button"
                title="Delete this discovery result" (click)="tryDeleteResult($event, rowData.Guid)">
                <i class="pi pi-trash">
                </i>
              </button>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div style="flex-grow: 1;"></div>

</div>

<confirmation-dialog message="Are you sure you want to delete this discovery result?"
  [display]="displayDeleteResultConfirm"
  (onYes)="deleteResult()" (onNo)="cancelDeleteResult()">
</confirmation-dialog>

<confirmation-dialog message="Are you sure you want to delete all discovery results?"
  [display]="displayDeleteAllResultsConfirm"
  (onYes)="deleteAllResults()" (onNo)="cancelDeleteAllResults()">
</confirmation-dialog>

